import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import RetentionPoliciesEditor from './RetentionPoliciesEditor';
import { retentionPoliciesToArray, retentionPoliciesToBE } from 'utils/retentionPolicies';

const RetentionPoliciesFields: React.FC<{
  selectedKey: string;
  setSelectedKey: (v: string) => void;
  formData: any;
  setFormData: (v: any) => void;
  setJsonValid: (v: boolean) => void;
}> = ({ selectedKey, setSelectedKey, formData, setFormData, setJsonValid }) => {
  const policies = retentionPoliciesToArray(formData);

  return (
    <>
      <Form.Group as={Row} className="mb-3" controlId="retentionKey">
        <Form.Label column sm="2">
          Key
        </Form.Label>
        <Col sm="10">
          <Form.Control type="text" name="key" value={selectedKey} onChange={(e) => setSelectedKey(e.target.value)} />
        </Col>
      </Form.Group>

      <RetentionPoliciesEditor
        policies={policies}
        onChange={(next) => {
          setFormData(retentionPoliciesToBE(next)); // keep BE format
          setJsonValid(true);
        }}
      />
    </>
  );
};

export default RetentionPoliciesFields;
